<mat-form-field [formGroup]="form"
                class="mat-block mat-block_with_symbol mat-block_placeholder-top"
                data-symbol="шт">
  <input matInput
         npNumber
         NumberInput="true"
         placeholder="Кількість мiсць"
         [maxValue]="999"
         [maxInputLength]="2"
         [formControlName]="controlName">
</mat-form-field>
